import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
// import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

import { AuthGuardService } from './services/auth-guard.service';
import { AppGuardService } from './services/app-guard.service';

const appRoutes: Routes = [
  // { path: '**', component: PageNotFoundComponent }
  {
    path: '',
    component: AppComponent,
    canActivate: [AuthGuardService, AppGuardService],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      enableTracing: false,
    })
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AuthGuardService,
    AppGuardService,
  ],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/app-routing.module.ts